<template>
  <div class="a-media" ref="sounds">
    <div id="breadcrumb">Dürrenmatt Stoffe /<br />Archiv / <strong>Tondokumente</strong></div>
    <div class="nav-header" id="soundHeader"></div>
      <Burger navType="Media" />
      <MediaMenu @clickedNavId="loadMedia" mediatype="sound" :tocJson="this.$store.state.soundToc"/>
       <AudioList v-if="!this.showAudioPlayer"></AudioList>
      <div class="audioplayer" v-if="this.showAudioPlayer">
            <div class="mediatitle">{{this.mediatitle}}</div>
          
            <audio id="audioplayer" controls  ref="audioplayer"  >
              <source v-bind:src="this.audioOptions.source" type="audio/mpeg"  />
              Ihr Browser unterstützt keine Audio-Wiedergabe...
            </audio>

            <div class="legend">{{this.medialegend}}</div>
      </div>  

  </div>
</template>


<script>
import MediaMenu from '@/components/MediaMenu.vue'
import Burger from '@/components/Burger.vue'
import AudioList from "@/components/AudioList.vue"

export default {
  name: 'sounds',
  components: {
    MediaMenu,
    AudioList,
    Burger    
  } ,
  data: function() {
      return { 
        audioOptions: {
          source: "",
          legend: ""
        },
        showAudioPlayer: false,
        medialegend: "",
        mediatitle: "",
        videoOptions: {
          autoplay: false,          
          controls: false 
        }
      }
  },

  methods: {
    loadMedia: function(value){ 

      this.showAudioPlayer = true
      //let mItem = this.$store.state.mediaItem
      this.$nextTick(() => {
          let url = "/audio/"
          if (location.hostname === "localhost" || location.hostname === "127.0.0.1"){
            //url = "//fd.ch.saphir.ch-meta.net/scans/"
            url = "//fd.ch.saphir.ch-meta.net/audio/"
          }
          this.$refs.audioplayer.load()
          this.$refs.audioplayer.play()
          
          this.audioOptions.source = url + this.$store.state.mediaItem.href
          this.audioOptions.legend = this.$store.state.mediaItem.text

          this.medialegend =  this.$store.state.mediaItem.text 
          this.mediatitle =  this.$store.state.mediaItem.title 
        })
    }
  },
    watch: {     
    $route(to, from) { 
      if (to.name.includes("tondokumente") && to.params.id !== "undefined" && !to.params.intro /* this.$store.state.mediaItem.href !== ""*/ ){         
        this.$nextTick(() => {  
          //var media = {}
          const tmpaud = _.find(this.$store.state.soundToc[0].level1, ['id', to.params.id]) 

          if (typeof tmpaud !== 'undefined') {
            let item = {
                href: tmpaud.href, 
                text: tmpaud.text,
                preview: tmpaud.preview,
                title: tmpaud.title
            }       
            this.$store.commit('updateMediaItem', item )
            this.videoOptions.autoplay = false
    
          }else {
            // video not found message!
          } 
          this.loadMedia() 
        })
      }else {
        this.showAudioPlayer = false
      }
    },
    //deep: true,
    //immediate:true      
  },

  mounted() {

    if (JSON.stringify(this.$store.state.soundToc) === '{}' ) {  
      
      this.$http.get("/json/tocMedia.json")
      .then(              
        response => {
          this.$store.commit('setSoundToc',response.data.level1)

          if (typeof this.$router.history.current.params.id !== 'undefined' ) {
            this.showAudioPlayer = true

            this.$nextTick(() => { 
              
              const tmpaud = _.find(this.$store.state.videoToc[1].level1, ['id', this.$router.history.current.params.id])    
           
              if (typeof tmpaud !== 'undefined') {
                let mediaItem = {
                    href: tmpaud.href, 
                    text: tmpaud.text,
                    preview: tmpaud.preview,
                    type: tmpaud.type,
                    title: tmpaud.title
                } 
                this.$store.commit('updateMediaItem',mediaItem)
              }
            })            
            this.loadMedia() 
          }else {
            this.showAudioPlayer = false
          }
          
          }
        )
    }          
  }
}

</script>

<style lang="scss" scoped>
.a-media {
  .audioplayer {
    margin: 100px auto;
    //border: 1px gray solid;
    padding: 2rem;
    width:auto;
    max-width:calc(600px + 4rem);
  }
  .mediatitle {
    font-size: 2rem;
    padding: 0 0 2rem;
    max-width: 100%;
    text-align: center;
    line-height: 2.2rem;
  }
}
</style>
